<div class="ring" [style.width.px]="size" [style.height.px]="size">
  <svg viewBox="0 0 100 100">
    <circle class="ring__track" cx="50" cy="50" r="45" />
    <circle class="ring__value" cx="50" cy="50" r="45" [style.stroke-dasharray.px]="circumference" [style.stroke-dashoffset.px]="dashOffset" />
  </svg>
  <div class="ring__label">
    <strong>{{ displayValue }}</strong>
    <span>{{ centerLabel }}</span>
  </div>
</div>
